import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useInitialData from '@/contexts/InitialDataContext/useInitialData';
import Spinner from '../Spinner';

/**
 * RootRedirect component handles navigation from the root path "/"
 * Shows a spinner while loading superagents, then redirects to the first agent's workflows
 */
function RootRedirect() {
    const navigate = useNavigate();
    const { data, isLoadingInitialData, error } = useInitialData();

    useEffect(() => {
        if (!isLoadingInitialData && !error && data.superagents.length > 0) {
            const firstAgent = data.superagents[0];
            navigate(`/agents/${firstAgent.id}/workflows`, { replace: true });
        }
    }, [isLoadingInitialData, error, data.superagents, navigate]);

    // Show error state if failed to load superagents
    if (error) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="flex flex-col items-center gap-4">
                    <p className="text-sm text-red-500">Failed to load agents. Please try again.</p>
                </div>
            </div>
        );
    }

    // Show empty state if no superagents found
    if (!isLoadingInitialData && data.superagents.length === 0) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="flex flex-col items-center gap-4">
                    <p className="text-sm text-gray-500">
                        No agents found. Please contact your administrator.
                    </p>
                </div>
            </div>
        );
    }

    // Show loading spinner while fetching superagents
    return (
        <div className="flex items-center justify-center min-h-screen">
            <div className="flex flex-col items-center gap-4">
                <Spinner size={32} />
                <p className="text-sm text-gray-500">Loading agents...</p>
            </div>
        </div>
    );
}

export default RootRedirect;
